import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';

// The hero is pinned to Same-Day Launch — the one offer that is fast, human,
// and owned in a single sentence. No rotation: a cold visitor should never
// have to catch the right slide. The marketing SaaS and free blueprint keep
// their own pages; they just don't get the front door.
const Hero = () => (
  <>
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-purple-600 text-white px-4 py-2 rounded-md z-50 focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:outline-none focus:shadow-lg transform focus:scale-105 transition-all duration-200 font-medium"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
    <section
      id="hero"
      className="relative min-h-screen flex flex-col justify-center items-center text-center px-4 overflow-hidden"
      aria-labelledby="hero-heading"
    >
      <div className="max-w-4xl mx-auto animate-[fadeIn_0.6s_ease-out]">
        <p className="font-mono text-sm uppercase tracking-widest text-purple-600 mb-6">
          Same-Day Launch · for small businesses that need a site now
        </p>

        <h1 id="hero-heading" className="text-4xl md:text-6xl lg:text-7xl font-bold font-sans text.heading tracking-tight leading-[1.05]">
          Your website, live on your domain,
          <span className="block text-purple-600 mt-2">before we hang up.</span>
        </h1>

        <p className="mt-8 text-lg md:text-2xl font-sans text.body max-w-2xl mx-auto leading-relaxed">
          One 60-minute video call with a real person. You leave with a working site, business email, and every login in your own name. Last one took 33 minutes.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          {/* /same-day-launch/ is a static page in public/, so <a> not Link. */}
          <a
            href="/same-day-launch/"
            className="py-3 px-8 rounded-lg transition-all duration-300 cursor-pointer bg-purple-600 text-white hover:bg-purple-700 hover:shadow-lg font-semibold text-lg inline-flex items-center justify-center gap-2 focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:outline-none"
          >
            See how it works · $497
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </a>
          <a
            href="sms:+15106299022?body=Hi%20Josh%2C%20I%20want%20a%20Same-Day%20Launch.%20My%20business%20is%3A%20"
            className="py-3 px-8 rounded-lg transition-all duration-300 border-2 border-purple-600 text-purple-600 hover:bg-purple-50 font-semibold text-lg inline-flex items-center justify-center focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:outline-none"
          >
            Text to book
          </a>
        </div>

        <p className="mt-5 text-sm font-sans text.muted">Flat price · no monthly lock-in · you own everything</p>

        <p className="mt-3 text-sm font-sans text.muted inline-flex items-center gap-1.5 justify-center flex-wrap">
          <MessageSquare className="w-4 h-4 text-purple-600" aria-hidden="true" />
          Building something bigger?{' '}
          <Link to="/portfolio" className="text-purple-600 font-medium hover:underline">
            See what we&apos;ve built
          </Link>{' '}
          or{' '}
          <Link to="/book" className="text-purple-600 font-medium hover:underline">
            book a free call
          </Link>
          .
        </p>

        <p className="mt-4 text-xs font-mono uppercase tracking-widest text.subtle">
          Own the source code, or let us host it · You decide
        </p>
      </div>
    </section>
  </>
);

export default Hero;
